import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { getBaseUrl } from '../utils/globals';
import RouterLink from './RouterLink';
export { Helmet };
/** Only render the child content if the test prop is truthy */
export const If = ({ children, test }) => {
    if (test)
        return React.createElement(React.Fragment, null, children);
    return null;
};
If.displayName = 'Meta.If';
/** Only render the child content if the test prop is falsy */
export const IfNot = ({ children, test }) => {
    if (!test)
        return React.createElement(React.Fragment, null, children);
    return null;
};
IfNot.displayName = 'Meta.IfNot';
/** Pass a string in as children and it will render to unescaped HTML,
 *  NOTE: scirpts will not be executed, if you need that use the InnerHTML component
 */
export const HTML = ({ children, ...props }) => {
    return React.createElement("div", Object.assign({}, props, { dangerouslySetInnerHTML: { __html: children } }));
};
HTML.displayName = 'Meta.HTML';
/** A link to the home page */
export const HomeLink = ({ children, className }) => {
    const baseUrl = getBaseUrl();
    return (React.createElement(RouterLink, { to: baseUrl, className: className, "data-testid": "home-link" }, children));
};
HomeLink.displayName = 'Meta.HomeLink';
/** A link to any extra routes you define
 * NOTE: the current language will be automatically pre-pended
 */
export const ExtraPageLink = ({ children, className, path, }) => {
    const baseUrl = getBaseUrl();
    return (React.createElement(RouterLink, { to: `${baseUrl}/${path}`, className: className }, children));
};
ExtraPageLink.displayName = 'Meta.ExtraPageLink';
//# sourceMappingURL=meta.js.map